import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'

import GovernancePdfs from '../GovernancePdfs/GovernancePdfs'
import MediaPdfsFilter from '../MediaPdfsLayout/MediaPdfsFilter'
import DataNotfound from '../DataNotfound/DataNotfound'
import useFetchFilteredData from '../../hooks/useFetchFilteredData'

import styles from './GovernancePdfFilters.module.scss'

const GovernancePdfFilters = ({ sectiondata, emptyMessage }) => {
  const year_filter = sectiondata?.year_filter
  const pdf_type = sectiondata?.pdf_type

  const [selectedFilter, setSelectedFilter] = useState({
    selectedYear: year_filter?.list?.length ? year_filter?.list[0] : null,
    selectedpdfType: pdf_type?.list.length ? pdf_type?.list[0] : null,
  })
  const [pdfs, setPdfs] = useState(sectiondata?.section2)

  const {
    data: filteredData,
    loading,
    error,
    setParams,
  } = useFetchFilteredData('corp-governance')

  useEffect(() => {
    if (filteredData) {
      let { sectiondata } = filteredData?.data
      setPdfs(sectiondata?.section2)
    }
  }, [filteredData])

  useEffect(() => {
    const params = `year_filter=${selectedFilter?.selectedYear?.value}`
    setParams(params)
  }, [selectedFilter])

  const handleFilterChange = (e, option, key) => {
    setSelectedFilter((prevState) => ({
      ...prevState,
      [key]: {
        ...option,
      },
    }))
  }

  return (
    <div className={styles.container}>
      <MediaPdfsFilter
        pdfTypeFilter={pdf_type}
        yearFilter={year_filter}
        selectedFilter={selectedFilter}
        handleFilterChange={handleFilterChange}
        filtersClass={styles.filtersClass}
      />
      {loading ? (
        <div className="flex justify-center">
          <Spinner />
        </div>
      ) : error || pdfs?.pdfs?.length === 0 ? (
        <DataNotfound description={emptyMessage} />
      ) : (
        <GovernancePdfs data={pdfs} />
      )}
    </div>
  )
}

export default GovernancePdfFilters
